import { useMatches } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function useTitle() {
    const match = useMatches();
    const { t } = useTranslation();

    const title = useMemo(() => {
        const lastMatchWithTitleFn = match
            .filter((match) => match.staticData.titleFn !== null)
            .slice(-1)[0];
        const titleFn = lastMatchWithTitleFn?.staticData.titleFn;
        return titleFn ? titleFn(t, lastMatchWithTitleFn.params) : "Dashboard";
    }, [match, t]);

    useEffect(() => {
        document.title = title;
    }, [title]);
    return title;
}
